import { lazy } from 'react';
import { Navigate } from 'react-router';
import { usePermissions } from '@/auth/useAuth';
import { isPlatformOnly } from '@/lib/permissions';

const DashboardPage = lazy(() => import('@/features/dashboard/DashboardPage'));

/** "/" — business dashboard, except for Nguyên Bình platform admins without business access: they land in the console. */
export default function HomeRoute() {
  const perms = usePermissions();
  if (isPlatformOnly(perms)) return <Navigate to="/platform/tenants" replace />;
  return <DashboardPage />;
}
